// Single public surface for everything network-shaped. Components import
// `api` (the configured implementation — mock by default, http when the
// real backend lands) and the value+type of each entity. They MUST NOT
// import from `./mock` or `./http` directly, and they MUST NOT shape
// network-bearing data anywhere outside this dir.

export { api } from "./client";
export { ApiError } from "./errors";
export { getAuthToken, setAuthToken, setSessionExpiredHandler } from "./token";
export * from "./types";
export * from "./promo-campaigns";
export * from "./ugc-articles";
